































































































































































































































































































































































































import { Component, Prop, Vue, Watch, Ref} from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { ViewpointApi, VIEWPOINT_API } from "@/api/ViewpointApi";
import vuetify from '@/plugins/vuetify';
import BasicInputForm from "@/components/forms/BasicInputForm.vue";
import ListInput from "@/components/forms/ListInput.vue";
import SupportWindow from "@/components/common/SupportWindow.vue";
//@ts-ignore
import { NotificationEventBus } from "@/EventBus";
import Sticky from 'vue-sticky-directive';
import ConfirmationDialog from "@/components/common/ConfirmationDialog.vue";
import ScoringKeyEditor from "@/components/scoring-key/ScoringKeyEditor.vue";
import Users from "@/store/modules/Users";
import Modelling from "@/store/modules/Modelling";
import Navigation from "@/store/modules/Navigation";
import Viewpoints from "@/store/modules/Viewpoints"
import Decisions from "@/store/modules/Decisions";
import Choices, { Choice } from "@/store/modules/Choices";
import Apps from "@/store/modules/Apps"
import ScoringKeyEditorDialog from "@/components/scoring-key/ScoringKeyEditorDialog.vue";
import { Urls } from "@/Urls";
import ViewpointNavigation from "@/components/navigation/ViewpointNavigation.vue";
import FactorNavigationWorkingModel from "@/components/navigation/FactorNavigationWorkingModel.vue";
import FactorNavigationPublishedModel from "@/components/navigation/FactorNavigationPublishedModel.vue";
import ChoiceNavigation from "@/components/navigation/ChoiceNavigation.vue";
import ScoringKeys, { ScoringKeyDefinition } from "@/store/modules/ScoringKeys";
import ChoiceVisibilitySelectorMenu from "@/components/workspace-options/ChoicesVisibilitySelectorMenu.vue";
import WorkspaceOptions from "@/store/modules/WorkspaceOptions";
import DecisionShareDialog from "@/components/decisions/DecisionManageUsersDialog.vue";
import FactorScoringDefinitionCreatorVuexDialog
    from "@/components/scoring-definition/FactorScoringDefinitionCreatorVuexDialog.vue";
import VuexDialogScoringKeyEditor from "@/components/scoring-key/ScoringKeyEditorVuexDialog.vue";
import FactorContributionVisibilitySwitch from "@/components/workspace-options/FactorContributionVisibilitySwitch.vue";
import ChoiceInputShareDialog from "@/components/share/ChoiceInputShareDialog.vue";
import ChoiceScoreInputShareDialog from "@/components/share/ChoiceScoreInputShareDialog.vue";
import { Decision } from "@/api/model/Decision";
import { Viewpoint } from "@/api/model/Viewpoint";
import _ from "lodash";
import ModelScoringKeyButtonTrigger from "@/components/scoring-key/ModelScoringKeyButtonTrigger.vue";
import ViewpointFactorVisibilityEditorVuexDialog
    from "@/components/viewpoint-factor-visibility/ViewpointFactorVisibilityEditorVuexDialog.vue";
import AppsAddRenameDialog from "@/components/apps/AppsAddRenameDialog.vue";
import AppsAdditionalMenu from "@/components/apps/AppsAdditionalMenu.vue";
import { set } from "vue/types/umd";
import AppNavTree from "@/components/apps/AppsNavTree.vue";
import { Auth } from "aws-amplify";
import DecisionSelector from '@/components/common/DecisionSelector.vue';
import Login from "@/views/Auth/Login.vue";
import AccountMenu from '@/components/account/AccountMenu.vue';
import { error } from "console";
import MainCommentPanel from '@/components/common/MainCommentPanel.vue';
import AutocreateViewpointDialog from '@/components/common/AutocreateViewpointDialog.vue';
import CreateChoiceDialog from "@/views/ChoiceCards/CreateChoiceDialog.vue";
import AppsSelector from '@/components/apps/AppsSelector.vue';
import Hero from '@/components/common/Hero.vue';

const usersModule = getModule(Users);
const modellingModule = getModule(Modelling);
const navigationModule = getModule(Navigation);
const viewpointsModule = getModule(Viewpoints);
const decisionsModule = getModule(Decisions);
const choicesModule = getModule(Choices);
const scoringKeysModule = getModule(ScoringKeys);
const workspaceOptionsModule = getModule(WorkspaceOptions);
const appsModule = getModule(Apps);

@Component({
    components: {
        ViewpointFactorVisibilityEditorVuexDialog,
        ModelScoringKeyButtonTrigger,
        ChoiceScoreInputShareDialog,
        ChoiceInputShareDialog,
        FactorContributionVisibilitySwitch,
        VuexDialogScoringKeyEditor,
        FactorScoringDefinitionCreatorVuexDialog,
        ScoringKeyEditorDialog,
        ScoringKeyEditor,
        BasicForm: BasicInputForm,
        ListInput,
        SupportWindow,
        ConfirmationDialog,
        ViewpointNavigation,
        FactorNavigationWorkingModel,
        FactorNavigationPublishedModel,
        ChoiceNavigation,
        ChoiceVisibilitySelectorMenu,
        DecisionShareDialog,
        AppsAddRenameDialog,
        AppsAdditionalMenu,
        AppNavTree,
        DecisionSelector,
        AppsSelector,
        Login,
        AccountMenu,
        MainCommentPanel,
        AutocreateViewpointDialog,
        CreateChoiceDialog,
        Hero
    },
    directives: {
        Sticky,
    },
})
export default class ViewpointAppEmbed2 extends Vue {

    @Prop()
    queryAppEmbedId!: string;

    @Prop()
    queryAppEmbedMenuId!: string;

    @Prop()
    queryActiveViewpointId!: string;

    @Prop()
    queryViewpointIds!: string[] | string;

    @Prop()
    queryDecisionId!: string;

    @Prop()
    queryChoiceId!: string;

    @Prop()
    queryShowNonContributing!: string;

    @Prop()
    queryVisibleChoices!: string[];

    @Prop()
    navDrawerProp!: boolean;

    @Prop()
    queryChoiceListIds!: string[];

    @Prop()
    queryActiveFactorId!: string;

    @Prop()
    queryFactorListIds!: string[];

    @Prop()
    queryViewpointListIds!: string[];

    @Prop()
    querySkipGroups!: string;

    @Prop()
    queryChoiceSort!: string;

    @Prop()
    queryViewpointSort!: string;

    @Prop()
    queryAutocomplete!: string;

    @Prop()
    queryEnd!: string;

    @Prop()
    queryOpenRight!: string;

    @Prop()
    queryOpenLeft!: string;

    @Prop()
    queryShowDesc!: string;
    
    @Prop()
    queryShowBars!: string;
    
    @Prop()
    queryShowIconScoring!: string

    @Prop()
    queryChoiceColumnWidth!: string;

    @Prop()
    queryViewpointColumnWidth!: string;

    @Prop()
    queryChoiceNumOfCols!: string;

    @Prop()
    queryTrimTopGroups!: string;

    @Prop()
    queryShowScores!: string;

    @Prop()
    queryShowKeys!: string;

    @Prop()
    queryShowComments!: string;

    @Prop()
    queryShowNonListFactors!: string;

    @Prop()
    queryChoiceFirstCol!: string;

    @Prop()
    queryShowCustomRange!: string;

    @Prop()
    queryViewpointFirstCol!: string;

    @Prop()
    queryRankChoiceCol!: string;

    @Prop()
    queryPinnedRight!: string;

    @Prop()
    queryPinnedLeft!: string;

    @Prop()
    queryPromote!: string;

    @Prop()
    queryAuthFlow!: string;

    @Prop()
    queryHomepage!: string;

    @Prop()
    queryAllowGenerateViewpoints!: string;

    @Prop()
    querySelectionMenu!: string;

    @Prop()
    queryViewpointSelectionMenu!: string;
    
    @Prop()
    queryChoiceSelectionMenu!: string;
    
    @Prop()
    queryFactorSelectionMenu!: string;

    @Prop()
    queryAutocreate!: string;

    @Prop()
    queryTemplateViewpoint!: string;

    @Prop()
    queryIncludeKeys!: string;

    @Prop()
    queryIncludeWeights!: string;

    @Prop()
    queryIncludeScores!: string;

    @Prop()
    queryMbDraggable!: string;

    @Prop()
    queryDenomScoring!: string;

    @Prop()
    queryStandardize!: string;

    @Prop()
    queryCreateChoice!: string;

    @Prop()
    queryBlockPinLeft!: string;

    @Prop()
    queryEditModel!: string;

    @Prop()
    queryEditContent!: string;

    @Prop()
    queryEditWeights!: string;

    @Prop()
    queryEditSumRule!: string;

    @Prop()
    queryEditScoringRule!: string;

    @Prop()
    queryEditScores!: string;

    @Prop()
    queryEditComments!: string;

    @Prop()
    queryVpTime!: string;

    @Prop()
    queryBrandingPrimary!: string;

    @Prop()
    queryChartTop!: string;

    @Prop()
    queryLockState!: string;

    private showHelp = false;
    private isAuthenticated = false;
    private isAuthChecked = false;
    private homepagePassed = false;
    private hamburger = true;
    private showAutocreateDialog = false;
    private decisions = [];
    get leftPanelWidth(){
        return workspaceOptionsModule.leftPanelWidth;
    }
    set leftPanelWidth( val: string){
        workspaceOptionsModule.setLeftPanelWidth(val);
    }
// NEW APP CODE
    @Ref()
    drawer!: HTMLDivElement

    setEvents() {
        const drawer = this.drawer;

        drawer.addEventListener(
            "mousedown",
            (e) => {
                drawer.style.transition = "initial";
                document.body.style.cursor = "col-resize";
                document.addEventListener("mousemove", this.resize, false);
            },
            false
        );
        
        document.addEventListener(
            "mouseup",
            () => {
                drawer.style.transition = "";
                document.body.style.cursor = "";
                document.removeEventListener("mousemove", this.resize, false);
                },
            false
        );

        drawer.addEventListener(
            "touchstart",
            (e) => {
                drawer.style.transition = "initial";
                document.body.style.cursor = "col-resize";
                document.addEventListener("touchmove", this.resizeMobile, false);
            },
            false
        );

        document.addEventListener(
            "touchend",
            () => {
                drawer.style.transition = "";
                document.body.style.cursor = "";
                document.removeEventListener("touchmove", this.resizeMobile, false);
                },
            false
        );
        // console.log(drawerBorder);
    }
    resize(e: any) {
        let f = e.clientX;
        if (f < 300){
            this.leftPanelWidth = '300px';
        } else if (f > window.innerWidth) {
            this.leftPanelWidth = window.innerWidth + 'px';
        } else {
            this.leftPanelWidth = f + "px";
        }
    }

    resizeMobile(e: any) {
        let f = e.changedTouches[0].clientX;
        if (f < 300){
            this.leftPanelWidth = '300px';
        } else if (f > window.innerWidth) {
            this.leftPanelWidth = window.innerWidth + 'px';
        } else {
            this.leftPanelWidth = f + "px";
        }
    }

    get menuItemLock() {
        return this.queryLockState == 'true';
    }

    get contentWidth() {
        if ( this.pinnedLeftMenu ){
            if( this.pinnedRight ){
                if( this.commentVertical ){
                    return `calc(100vw - ${this.leftPanelWidth} )`;
                } else {
                    return `calc(100vw - ${this.leftPanelWidth} - ${this.commentRightWidth}px)`;
                }
            } else {
                if(this.commentVertical){
                    return `calc(100vw - ${this.leftPanelWidth} )`
                } else {
                    return `calc(100vw - ${this.leftPanelWidth} - 40px)`
                }
            }
        }else{
            if( this.pinnedRight ){
                if( this.commentVertical ){
                    return `calc(100vw - 40px )`;
                } else {
                    return `calc(100vw - 40px - ${this.commentRightWidth}px)`;
                }
            } else {
                if(this.commentVertical){
                    return `calc(100vw - 40px )`
                } else {
                    return `calc(100vw - 80px )`
                }
            }
        }
       
    }

    get commentRightWidth() {
        return workspaceOptionsModule.commentRightWidth;
    }

    get commentVertical() {
        return workspaceOptionsModule.commentVertical;
    }
    // private selectedApp = "";
    get apps(){
        return appsModule.appList;
    }

    get appName(){
        return appsModule.appName;
    }

    get pinnedLeftMenu() {
        if (this.leftMenuOpen) {
            return this.pinnedLeft;
        }
        return false;
    }

    /*
        Property is called showHelpPage but calls "showHomePage" from module
        because help page used to be called home page
    */
    get showHelpPage() {
        if (this.selectedAppModule) {
            if (this.selectedAppModule.showHomepage) {
                return this.selectedAppModule.showHomepage;
            }
        }
        return false;
    }

    get leftMenuOpen() {
        return this.multiLinks;
    }

    get multiDecisions() {
        if (this.decisions) {
            return this.decisions.length > 1;
        }
        return false;
    }

    get multiLinks() {
        if (this.selectedAppModule) {
            if (this.selectedAppModule.children.length == 1 
                && this.selectedAppModule.children[0].children.length == 0) {
                return false;
            }
        }
        return true;
    }

    get selectedApp(){
        // this.selectedApp = appsModule.appId;
        return appsModule.appId;
    }

    get selectedAppModule() {
        if (this.apps && this.apps.length > 0 && this.selectedApp != '') {
            return this.apps.find((x) => x.id === this.selectedApp);
        } else {
            return null;
        }
    }

    set selectedApp(id:string){
        appsModule.setSelectedAppId(id);
    }

    get appsDictionary(){
        return appsModule.appsDictionary;
    }

    get homepageHtml() {
        return _.unescape(this.appsDictionary[this.selectedApp]?.homepage) 
    }

    // Fills the APP dropdown
    get allApps(): any[] {
        if (this.apps) {
            let res: any[] = [];
            this.apps.forEach( (app: any, i: number) => {
                res.push({id: i, name: app.name});
            });
            // console.log(res);
            return res;
        }
    }

    get appMenuId() {
        return appsModule.activeAppMenuId;
    }

    get openLeft(){
        return workspaceOptionsModule.openLeft;
    }

    get openRight(){
        return workspaceOptionsModule.openRight;
    }

    set openLeft(open: boolean) {
        workspaceOptionsModule.setOpenLeft(open);
    }

    set openRight(open: boolean) {
        workspaceOptionsModule.setOpenRightEmbed(open);
    }

    get pinnedLeft(){
        return workspaceOptionsModule.pinnedLeft;
    }

    get commentMenuOpen() {
        return workspaceOptionsModule.commentMenuOpen;
    }

    set pinnedLeft(val: boolean){
        workspaceOptionsModule.changePinnedLeft(val);
    }

    get pinnedRight(){
        return workspaceOptionsModule.pinnedRight;
    }

    set pinnedRight(val: boolean){
        workspaceOptionsModule.changePinnedRight(val);
    }

    get isHomepage() {
        return workspaceOptionsModule.isHomepage;
    }

    set isHomepage(isHomepage: boolean) {
        workspaceOptionsModule.setIsHomepage(isHomepage);
    }

    get appletIcon() {
        return 'mdi-view-grid';
    }

    get heroTitle() {
        return appsModule.appName;
    }

    get showHero() {
        if (this.selectedAppModule && this.selectedAppModule.hasOwnProperty('hero')) {
            return this.selectedAppModule.hero;
        }
        return false;
    }

    get heroCoverImage() {
        if (this.selectedAppModule.hasOwnProperty('imageMain')) {
            return this.selectedAppModule.imageMain;
        }
        return null;
    }

    private getDecisionURL(decisionId: string) {
        let link = '';
        link = `http${window.location.hostname === 'localhost' ? '' : 's'}://${
            window.location.host
        }` + this.generateUrl(decisionId);
        
        return link;
    }

    private async updateCurrentDecision(decision: Decision | null) {
        if (decision) {
            this.initialLoad = true;
            let currentAppName = appsModule.appName;

            appsModule.setCurrentAppUrl('');

            await decisionsModule.selectDecision(decision.decisionId).then(res=>{
                this.$emit('selectedDecision', decision);
            })

            new Promise((resolve) => {
                resolve( appsModule.apps.find(app =>  {return app.name === currentAppName}) );
            }).then((targetApp) => {
                if (targetApp) {
                     window.location.href = this.generateLink(targetApp)
                }
                else {
                    this.initialLoad = false;
                    this.$router.push({ name: 'AppletsGallery' })
                }

            })
        }
        
    }

    private getAppsUrl(url: string) {

        let mainPath:string;
        if(url.substring(0,5).toLowerCase() === Urls.APP_EMBED){
            mainPath = Urls.APP_EMBED;
        }else{
            mainPath = Urls.APP_EMBED;
        }
        // Remove trailing '/' if there
        mainPath = mainPath.charAt(mainPath.length - 1) == '/' ? 
            mainPath.substr(0, mainPath.length - 1) : mainPath;
            
        let re = new RegExp(
            '^(http:|https:){1}[/]{2}([a-zA-Z0-9.:-]*[/]{0})([/]{1}[/]*){1}'
        );
        if (re.test(url)) {
            url = mainPath + url.replace(re, '/');
            return url;
        } else {
            return mainPath + url;
        }
    }

    private generateLink(item: any) {
        let link = '';
        link = `http${window.location.hostname === 'localhost' ? '' : 's'}://${
            window.location.host
        }`;
        if(item.children && item.children.length > 0) {
            link = `${link}${this.getAppsUrl(item?.children[0].href)}`;
            link = `${link}&homepage=${item.homepage && item.showHomepage}&pinnedLeft=true&appEmbedId=${item.id}&appEmbedMenuId=${item.id}`
            return link
        }
        
    }

    private drawerMouseOn() {
        if (!this.pinnedLeftMenu) {
            this.openLeft = true;
        }
    }

    @Watch('queryChartTop')
    private onChangeChartTop() {
        workspaceOptionsModule.setChartTop(this.queryChartTop === 'true');
    }

    @Watch('queryShowBars')
    private onChangeShowBars() {
        if (this.queryShowBars != null) {
            workspaceOptionsModule.setScoreBarVisibility(this.queryShowBars === 'true');
        } else {
            workspaceOptionsModule.setScoreBarVisibility(false);
        }
    }

    @Watch('queryShowIconScoring')
    private onChangeIconScoring() {
        if (this.queryShowIconScoring != null) {
            workspaceOptionsModule.changeIconScoring(this.queryShowIconScoring === 'true');
        } else {
            workspaceOptionsModule.changeIconScoring(false);
        }
    }

    @Watch('queryChoiceColumnWidth')
    private onChangeChoiceColumnWidth() {
        if (this.queryChoiceColumnWidth != null) {
            workspaceOptionsModule.changeChoiceColumnWidth(Number(this.queryChoiceColumnWidth));
        } else {
            workspaceOptionsModule.changeChoiceColumnWidth(150);
        }
    }

    @Watch('queryViewpointColumnWidth')
    private onChangeViewpointColumnWidth() {
        if (this.queryViewpointColumnWidth != null) {
            workspaceOptionsModule.changeViewpointColumnWidth(Number(this.queryViewpointColumnWidth));
        } else {
            workspaceOptionsModule.changeViewpointColumnWidth(150);
        }
    }

    @Watch('queryChoiceNumOfCols')
    private onChangeChoiceNumOfCols() {
        if (this.queryChoiceNumOfCols != null) {
            workspaceOptionsModule.setNumOfCols(Number(this.queryChoiceNumOfCols));
        } else {
            workspaceOptionsModule.setNumOfCols(3);
        }
    }

    @Watch('queryActiveViewpointId')
    private setActiveViewpointId(){
        viewpointsModule.selectActiveViewpoint(this.queryActiveViewpointId);
    }

    @Watch('queryFactorListIds')
    private onChangeFactorList(){
        workspaceOptionsModule.updateSavedFactorLists((typeof this.queryFactorListIds === 'string')? [this.queryFactorListIds]: this.queryFactorListIds);
            
    }

    @Watch('queryActiveFactorId')
    private onChangeActiveFactor(){
       workspaceOptionsModule.selectBreadcrumbItem(this.queryActiveFactorId);
            
    }

    @Watch('querySkipGroups')
    private onChangeSkipGroups(){
       workspaceOptionsModule.changeSkipGroups(this.querySkipGroups === 'true');           
    }

    @Watch('queryViewpointListIds')
    private onChangeViewpointList(){
        workspaceOptionsModule.updateSavedViewpointLists((typeof this.queryViewpointListIds === 'string')? [this.queryViewpointListIds]: this.queryViewpointListIds);
 
    }

    @Watch('queryViewpointIds')
    private async onchangeViewpoints() {
        if ( this.queryViewpointIds ) {
            let newViewpoints = Array.isArray(this.queryViewpointIds) ? this.queryViewpointIds : [this.queryViewpointIds]
            if ( newViewpoints.length > 0 ) {
                // Remove viewpoints that aren't in new array
                viewpointsModule.selectedViewpointIds.forEach((vp) => {
                    if (!newViewpoints.includes(vp)) {
                        viewpointsModule.deselectViewpoint(vp);
                    }
                })
                newViewpoints.forEach(vp => viewpointsModule.selectViewpoint(vp));
                if (!this.queryActiveViewpointId) {
                    viewpointsModule.selectActiveViewpoint(newViewpoints[0]);
                }
            }
        } 
        
        else if (this.decisionViewpointsList.length > 0) {
            await viewpointsModule.clearSelecteViewpoints();
            viewpointsModule.selectViewpoint(this.decisionViewpointsList[0].viewpointId);
            if (!this.queryActiveViewpointId) {
                viewpointsModule.selectActiveViewpoint(this.decisionViewpointsList[0].viewpointId);
            }
        }
    }

    @Watch('queryChoiceListIds')
    private onChangeChoiceList(){
        workspaceOptionsModule.updateSavedChoiceLists((typeof this.queryChoiceListIds === 'string')? [this.queryChoiceListIds]: this.queryChoiceListIds);
 
    }

    @Watch('queryTrimTopGroups')
    private onChangeQueryTrimTopGroups(){
       workspaceOptionsModule.changeTrimTopGroups(this.queryTrimTopGroups === 'true');           
    }

    @Watch('queryMbDraggable')
    private onChangeMbDraggable(){
       workspaceOptionsModule.setMbDraggable(this.queryMbDraggable === 'true');           
    }

    @Watch('querySelectionMenu')
    private onChangeQuerySelectionMenu() {
        appsModule.setSelectionMenu(this.querySelectionMenu === 'true');
    }

    @Watch('queryViewpointSelectionMenu')
    private onChangeQueryViewpointSelectionMenu() {
        appsModule.setViewpointSelectionMenu(this.queryViewpointSelectionMenu === 'true');
    }

    @Watch('queryChoiceSelectionMenu')
    private onChangeQueryChoiceSelectionMenu() {
        appsModule.setChoiceSelectionMenu(this.queryChoiceSelectionMenu === 'true');
    }

    @Watch('queryFactorSelectionMenu')
    private onChangeQueryFactorSelectionMenu() {
        appsModule.setFactorSelectionMenu(this.queryFactorSelectionMenu === 'true');
    }
    
    @Watch('queryShowDesc')
    private onChangeShowDesc(){
        if(this.queryShowDesc!= null){
            workspaceOptionsModule.setDescriptionVisibility(this.queryShowDesc === 'true');
        }else{
            workspaceOptionsModule.setDescriptionVisibility(false);
        }
    }

    @Watch('queryDenomScoring')
    private onChangeDenomScoring() {
        if (this.queryDenomScoring != null) {
            workspaceOptionsModule.changeDenominatorScoring(this.queryDenomScoring === 'true');
        } else {
            workspaceOptionsModule.changeDenominatorScoring(false);
        }
    }

    @Watch('queryStandardize')
    private onChangeStandardize() {
        if (this.queryStandardize != null) {
            workspaceOptionsModule.changeStandardizeDenominator(this.queryStandardize === 'true');
        } else {
            workspaceOptionsModule.changeStandardizeDenominator(false);
        }
    }

    @Watch('queryBrandingPrimary')
    private onChangeBrandingPrimary(colour) {
        if ( colour != null && colour != '' ) {
            let re = /^([0-9A-F]{3}){1,2}$/i;
            if(re.test( colour )) {
                vuetify.framework.theme.themes.light.primary = '#'+colour;
                vuetify.framework.theme.themes.light.indigo = '#'+colour;
                vuetify.framework.theme.themes.light.vpPrimary = '#'+colour;
                vuetify.framework.theme.themes.light.blue = '#'+colour;
                vuetify.framework.theme.themes.light.accent = '#'+colour;
            }
        }
        else {
            if (!this.$router.currentRoute.path.includes(Urls.GALLERY_EMBED2)) {
                vuetify.framework.theme.themes.light = {...vuetify.userPreset.theme.themes.light};
            }
        }
    }

    // Fills the left nav
    get appMenu() {
        // console.log(this.allApps);
        if (!this.allApps.length) return [];
        let res: any[] = [];
        if (this.appsDictionary[this.selectedApp] && this.appsDictionary[this.selectedApp].hasOwnProperty('children')) {
            res = this.appsDictionary[this.selectedApp].children;
            // console.log(res);
            return res;
        } else {
            return [];
        }
    }

    get appLabel(){
        return this.selectedApp ? "" : "Please create or select an App";
    }

    mounted() {
        if (this.$route.path === '/') {
            this.navTabs = 0;
        } else if (this.$route.path === this.URLS.TEMPLATE_BUILDER) {
            this.navTabs = 0;
        } else if (this.$route.path === this.URLS.CHOICE_SUBMITTER) {
            this.navTabs = 1;
        } else {
            this.navTabs = 2;
        }
        this.setEvents();
        /*
        if (this.$cookies.isKey("vp-form-width")) {
            this.sliderRight = this.$cookies.get("vp-form-width")
            this.sliderLeft = -1 * this.sliderRight;
        }
        */

        this.initialize();

        setTimeout(() => this.increment++, 2000);
        // setTimeout(() => this.increment++, 20000);

        this.sliderPageWidth = [this.sliderLeft, this.sliderRight];

        NotificationEventBus.getEventBus().$on('choice-updated', (choice: any) => {
            choicesModule.setChoice(choice)
        });
    }

 

    async initialize() {
        try{
            let authUser = await Auth.currentUserInfo();
            if (authUser) {
                    this.isAuthenticated = true;
            }
            if(!this.isAuthenticated) {
                this.isAuthChecked = true;
                Vue.$cookies.set('app-share-url', this.$route.fullPath);

            }
            if (this.queryDecisionId && this.isAuthenticated) {
                let unauthUser: any;
                let authUser = await Auth.currentUserInfo();
                let userId: string;
                
                await decisionsModule.selectDecision(null);
                const decisionMap: { [decisionId: string]: Decision }  = await decisionsModule.fetchDecisions();

                
                let linkRole: string;
                if (this.queryPromote && this.queryPromote === 'true') {
                    linkRole = 'ADMIN';
                } else {
                    linkRole = 'EDIT';
                }

                this.isAuthChecked = true;

                if (authUser) {
                    userId = authUser.username;
                    this.isAuthenticated = true;
                    if (decisionMap && decisionMap[this.queryDecisionId] && userId === decisionMap[this.queryDecisionId].ownerUserId) {
                        linkRole = 'OWNER';
                    }
                    if (linkRole !== 'OWNER') {
                        let decisionTeam: any;
                        let updatedDecisionTeam: any;
                        try {
                            decisionTeam = await VIEWPOINT_API.getDecisionUsers(this.queryDecisionId);
                        
                            let joinDecisionRole = linkRole;
                            if (decisionTeam && decisionTeam.length > 0) {
                                const decisionUser = _.find(decisionTeam, {'userId': userId});
                                if (decisionUser === undefined) {
                                    await VIEWPOINT_API.joinDecisionAutocomplete(this.queryDecisionId, userId, 'USER');
                                } else if (decisionUser.hasOwnProperty('permissionAccess') && decisionUser.permissionAccess === 'EDIT' && joinDecisionRole === 'ADMIN') {
                                    await VIEWPOINT_API.joinDecisionAutocomplete(this.queryDecisionId, userId, joinDecisionRole);
                                }
                            }
                            await decisionsModule.fetchDecisions();

                            updatedDecisionTeam = await VIEWPOINT_API.getDecisionUsers(this.queryDecisionId);
                            if (updatedDecisionTeam && updatedDecisionTeam.length > 0) {
                                let updatedDecisionUser = _.find(updatedDecisionTeam, {'userId': userId});
                                // if (!updatedDecisionUser || 
                                //     updatedDecisionUser.permissionAccess.toUpperCase() !== 'ADMIN' && 
                                //     updatedDecisionUser.permissionAccess.toUpperCase() !== 'EDIT'
                                //     ) {
                                //     this.$router.push({ name: 'AccessRestriction' });
                                // }
                            }
                        } catch(err) {
                            console.error(err);
                        }
                    }
                    
                } else {
                        unauthUser = await Auth.currentCredentials();
                        userId = unauthUser.identityId;
                        navigationModule.setAnonUserId(userId);
                        // commented this for now because we don't need to call joinDecisionAutocomplete 
                        //  if user is not authUser we just need to set a cookie and join a new user to Decision 
                        // in part of code where we checking if (linkRole !== 'OWNER')
                        // await VIEWPOINT_API.joinDecisionAutocomplete(this.queryDecisionId, userId, 'EDIT');
                        // kathy - save cookie for app-share-url
                        Vue.$cookies.set('app-share-url', this.$route.fullPath);
                }
                
                await decisionsModule.selectDecision(this.queryDecisionId);
                // anonymous user not able to get apps, so nothing displays
                await appsModule.fetchAppsByDecision(this.queryDecisionId);
                
                await this.getUrlParams(userId);

            }
        } catch (err) {
            console.log(err);
        }
        
        this.initialLoad = false;
    }

    async getUrlParams(userId: string) {
        //Check if queryAutocomplete flag, if true and user owns no vp then create a new one
        if(this.queryAutocreate === 'true') {
            
            this.selectActiveViewpoint(null);
            this.showCreateViewpointDialog = true;
        }

        if (this.queryEnd && this.queryEnd.length) {
            navigationModule.setRequiredEnd(this.queryEnd);
        }

        if (this.queryViewpointIds && Array.isArray(this.queryViewpointIds) && this.queryViewpointIds.length) {
            this.queryViewpointIds.forEach(vp => viewpointsModule.selectViewpoint(vp));
        } else if (!Array.isArray(this.queryViewpointIds)) {
            viewpointsModule.selectViewpoint(this.queryViewpointIds);
        } else if (this.decisionViewpointsList.length > 0) {
            viewpointsModule.selectViewpoint(this.decisionViewpointsList[0].viewpointId);
        }

        if (this.queryActiveFactorId) {
            workspaceOptionsModule.selectBreadcrumbItem(this.queryActiveFactorId);
        }

        if (this.queryActiveViewpointId && this.queryAutocreate != 'true') {
            viewpointsModule.selectActiveViewpoint(this.queryActiveViewpointId);
        }
        else if ( !this.queryActiveViewpointId && this.queryAutocreate != 'true' ) {
            if (this.queryViewpointIds && Array.isArray(this.queryViewpointIds) && this.queryViewpointIds.length) {
                viewpointsModule.selectActiveViewpoint(this.queryViewpointIds[0])
            } else if (!Array.isArray(this.queryViewpointIds)) {
                viewpointsModule.selectActiveViewpoint(this.queryViewpointIds);
            } else if (this.decisionViewpointsList.length > 0) {
                viewpointsModule.selectActiveViewpoint(this.decisionViewpointsList[0].viewpointId);
            }
        }

        if(this.queryCreateChoice === 'true') {
            this.showCreateChoiceDialog = true;
        }

        if(this.queryCreateChoice != 'true') {
            if (this.queryChoiceId) {
                choicesModule.selectChoice(this.queryChoiceId);
            } else if (choicesModule.choiceIds.length) {
                choicesModule.selectChoice(choicesModule.choiceIds[0]);
            }
        }


        if (this.queryFactorListIds != null) {
            workspaceOptionsModule.updateSavedFactorLists((typeof this.queryFactorListIds === 'string')? [this.queryFactorListIds]: this.queryFactorListIds);
        }

        if (this.queryViewpointListIds != null) {
            workspaceOptionsModule.updateSavedViewpointLists((typeof this.queryViewpointListIds === 'string')? [this.queryViewpointListIds]: this.queryViewpointListIds);
        }

        if (this.queryChoiceListIds != null) {
            workspaceOptionsModule.updateSavedChoiceLists((typeof this.queryChoiceListIds === 'string')? [this.queryChoiceListIds]: this.queryChoiceListIds);
        }

        if (this.queryChoiceSort != null) {
            workspaceOptionsModule.changeChoiceSort(parseInt(this.queryChoiceSort));
        }

        if (this.queryViewpointSort != null) {
            workspaceOptionsModule.changeViewpointSort(parseInt(this.queryViewpointSort));
        }

        if (this.queryVisibleChoices) {
            workspaceOptionsModule.showSetChoicesOnly(this.queryVisibleChoices);
        }

        if (this.queryShowBars != null) {
            workspaceOptionsModule.setScoreBarVisibility(this.queryShowBars === 'true');
        } 

        if (this.queryPinnedLeft != null) {
            if (!this.multiLinks) {
                if ( Array.isArray(this.queryPinnedLeft) ) {
                    workspaceOptionsModule.setPinnedLeft(this.queryPinnedLeft[0] === 'true');
                }
                else {
                    workspaceOptionsModule.setPinnedLeft(this.queryPinnedLeft === 'true');
                }
            }
            else {
                workspaceOptionsModule.setPinnedLeft(true)
            }
        }

        if (this.queryOpenLeft != null) {
            workspaceOptionsModule.setOpenLeft(this.queryOpenLeft === 'true');
        }

        if (this.queryPinnedRight != null) {
            workspaceOptionsModule.setPinnedRight(this.queryPinnedRight === 'true');
        }

        if (this.queryOpenRight != null) {
            workspaceOptionsModule.setOpenRight(this.queryOpenRight === 'true');
        }

        if (this.querySkipGroups != null) {
            workspaceOptionsModule.changeSkipGroups(this.querySkipGroups === 'true');
        }

        if (this.queryTrimTopGroups != null) {
            workspaceOptionsModule.changeTrimTopGroups(this.queryTrimTopGroups === 'true');
        }

        if (this.queryShowScores != null) {
            workspaceOptionsModule.setScoresVisibility(this.queryShowScores === 'true');
        }

        if (this.queryShowKeys != null) {
            workspaceOptionsModule.setKeysVisibility(this.queryShowKeys === 'true');
        }

        if (this.queryShowNonListFactors != null) {
            workspaceOptionsModule.setShowNonListFactors(this.queryShowNonListFactors == 'true');
        }

        if (this.queryShowComments != null) {
            workspaceOptionsModule.setKeysVisibility(this.queryShowComments === 'true');
        }

        if (this.queryShowDesc != null) {
            workspaceOptionsModule.setDescriptionVisibility(this.queryShowDesc === 'true');
        }

        if (this.queryShowIconScoring != null) {
            workspaceOptionsModule.changeIconScoring(this.queryShowIconScoring === 'true');
        }

        if (this.queryChoiceFirstCol != null) {
            workspaceOptionsModule.setChoiceFirstCol(Number(this.queryChoiceFirstCol));
        } else {
            workspaceOptionsModule.setChoiceFirstCol(600);
        }

        if (this.queryViewpointColumnWidth != null) {
            workspaceOptionsModule.changeViewpointColumnWidth(Number(this.queryViewpointColumnWidth));
        } else {
            workspaceOptionsModule.changeViewpointColumnWidth(200);
        }

        if (this.queryChoiceColumnWidth != null) {
            workspaceOptionsModule.changeChoiceColumnWidth(Number(this.queryChoiceColumnWidth));
        } else {
            workspaceOptionsModule.changeChoiceColumnWidth(200);
        }

        if (this.queryChoiceNumOfCols != null) {
            workspaceOptionsModule.setNumOfCols(Number(this.queryChoiceNumOfCols));
        } else {
            workspaceOptionsModule.setNumOfCols(3);
        }

        if (this.queryRankChoiceCol != null) {
            workspaceOptionsModule.setRankChoiceCol(Number(this.queryRankChoiceCol));
        } else {
            workspaceOptionsModule.setRankChoiceCol(150);
        }

        if (this.queryShowCustomRange != null) {
            workspaceOptionsModule.changeCustomRangeActive(this.queryShowCustomRange === 'true');
        }

        if (this.queryViewpointFirstCol != null) {
            workspaceOptionsModule.setViewpointFirstCol(Number(this.queryViewpointFirstCol));
        } else {
            workspaceOptionsModule.setViewpointFirstCol(600);
        }


        // APPS TEST
        if (this.queryAppEmbedId != null){
            appsModule.setSelectedAppId(this.queryAppEmbedId);
        }

        if(this.queryAppEmbedMenuId != null){
            appsModule.selectAppMenuById(this.queryAppEmbedMenuId);
        }

        if(this.queryHomepage != null) {
        workspaceOptionsModule.setIsHomepage (this.queryHomepage === 'true');
        }

        if(this.queryMbDraggable != null) {
        workspaceOptionsModule.setMbDraggable (this.queryMbDraggable === 'true');
        }

        // APPS TEST
        if (this.queryAppEmbedId != null){
            appsModule.setSelectedAppId(this.queryAppEmbedId);
        }

        if (this.queryAllowGenerateViewpoints != null) {
            workspaceOptionsModule.setAllowGenerateViewpoints (this.queryAllowGenerateViewpoints === 'true');
        }

        if (this.querySelectionMenu != null) {
            appsModule.setSelectionMenu(this.querySelectionMenu === 'true');
        }

        if (this.queryViewpointSelectionMenu != null) {
            appsModule.setViewpointSelectionMenu(this.queryViewpointSelectionMenu === 'true');
        }

        if (this.queryChoiceSelectionMenu != null) {
            appsModule.setChoiceSelectionMenu(this.queryChoiceSelectionMenu === 'true');
        }

        if (this.queryFactorSelectionMenu != null) {
            appsModule.setFactorSelectionMenu(this.queryFactorSelectionMenu === 'true');
        }

        if (this.queryStandardize != null) {
            workspaceOptionsModule.changeStandardizeDenominator(this.queryStandardize === 'true');
        }

        if ( this.queryDenomScoring != null) {
            workspaceOptionsModule.changeDenominatorScoring(this.queryDenomScoring === 'true')
        }

        // Permissions
        if ( this.queryEditModel != null) {
            workspaceOptionsModule.setEditModel(this.queryEditModel === 'true')
        }

        if ( this.queryEditContent != null) {
            workspaceOptionsModule.setEditContent(this.queryEditContent === 'true')
        }

        if ( this.queryEditWeights != null) {
            workspaceOptionsModule.setEditWeights(this.queryEditWeights === 'true')
        }

        if ( this.queryEditSumRule != null) {
            workspaceOptionsModule.setEditSumRule(this.queryEditSumRule === 'true')
        }

        if ( this.queryEditScoringRule != null) {
            workspaceOptionsModule.setEditScoringRule(this.queryEditScoringRule === 'true')
        }

        if ( this.queryEditScores != null) {
            workspaceOptionsModule.setEditScores(this.queryEditScores === 'true')
        }

        if ( this.queryEditComments != null) {
            workspaceOptionsModule.setEditComments(this.queryEditComments === 'true')
        }

        if ( this.queryChartTop != null ) {
            workspaceOptionsModule.setChartTop(this.queryChartTop === 'true');
        }

        if ( this.queryVpTime && decisionsModule.selectedDecisionUsers[userId] ) {                        
            const perms = {
                '1': 'ADMIN',
                '2': 'EDIT',
                '3': 'USER',
            }
            if ( perms[this.queryVpTime] ) {
                await decisionsModule.setSelectedDecisionUserPermission( {
                    id: userId, 
                    permission: perms[this.queryVpTime]
                });
            }
        }

        this.onChangeBrandingPrimary(this.queryBrandingPrimary)
        workspaceOptionsModule.openAllExpansions()
    }

    private readonly URLS = Urls;
    private initialLoad = true;
    private increment: number = 1;

    navDrawer: boolean = this.navDrawerProp;

    private loadingResources = false;
    private processing = false;

    private createDecisionDialog = false;
    private editDecisionDialog = false;
    private createViewpointDialog = false;

    private section: string = this.URLS.TEMPLATE_BUILDER;
    private fullPath: string = '';

    private staticPageWidth = [-50, 50];
    private sliderPageWidth: any[] = [];
    private sliderLeft: number = -50;
    private sliderRight: number = 50;

    private panelLeft: boolean = true;
    private navTabs: number = 0;
    private scoreTabs: string = '';

    private searchFactors: string | null = null;
    private decisionSelectorMenuShow: boolean = false;


    get isOwner(): boolean {
        return (this.userId != null) && (this.userId === this.decisionOwnerUserId);
    }

    get isUserAdminOwner(): boolean {
        if (this.isOwner) {
            return true;
        }

        if (this.userId) {
            return ['OWNER', 'ADMIN'].includes(this.userPermissions);
        }
        
        return false;
    }

    get userId(): string | undefined {
        if (usersModule.currentUserProfile) {
            return usersModule.currentUserProfile.userId;
        }
        return undefined;
    }

    get decisionOwnerUserId(): string | undefined {
        if (decisionsModule.selectedDecision) {
            return decisionsModule.selectedDecision.ownerUserId;
        }
    }

    get scoreItems() {
        let items = [
            {text: 'Content', tooltip: '', url: this.URLS.CHOICE_SUBMITTER_EMBED             , section: this.URLS.CHOICE_SUBMITTER_EMBED},
            {text: 'Content', tooltip: '', url: this.URLS.CHOICE_CARDS_EMBED                 , section: this.URLS.CHOICE_SUBMITTER_EMBED},
            {text: `${this.pluralViewpointLabel}`, tooltip: '', url: this.URLS.WEIGHTING_EMBED                 , section: this.URLS.WEIGHTING_EMBED},
            {text: 'Compare Content', tooltip: '', url: this.URLS.CHOICE_SCORER_COMPARE_EMBED, section: this.URLS.WEIGHTING_EMBED},
            {text: `Compare ${this.pluralViewpointLabel}`, tooltip: '', url: this.URLS.CHOICE_SCORER_EMBED     , section: this.URLS.WEIGHTING_EMBED},
            {text: 'Classify & Rank', tooltip: '', url: this.URLS.CHOICE_SCORER_BINS_EMBED   , section: this.URLS.WEIGHTING_EMBED},
            {text: 'Results', tooltip: '', url: this.URLS.RESULTS_EMBED   , section: this.URLS.WEIGHTING_EMBED},

        ];

        let decisionUsers = decisionsModule.selectedDecisionUsers
        if (this.currentUserProfile && decisionUsers[this.currentUserProfile.userId]
            && ['OWNER', 'ADMIN'].includes(decisionUsers[this.currentUserProfile.userId].permissionAccess)) {
            items.splice(0, 0, {text: 'Model', tooltip: '', url: this.URLS.TEMPLATE_BUILDER_EMBED, section: this.URLS.TEMPLATE_BUILDER_EMBED})
            if (this.$route.path === this.URLS.TEMPLATE_BUILDER_EMBED) {
                this.scoreTabs = this.URLS.TEMPLATE_BUILDER_EMBED;
            }
        }
        return items;
    }

    get userPermissions() {
        return decisionsModule.selectedDecisionUsers[this.userId].permissionAccess;
    }


    get factorResources() {
        return modellingModule.publishedModelFactorResources;
    }

    get selectedFactorResourceItemId() {
        return workspaceOptionsModule.selectedPathItemId;
    }

    get draftFactorResources() {
        return modellingModule.workingModelFactorResources;
    }

    get selectedDraftFactorResourceItemId() {
        return workspaceOptionsModule.draftSelectedPathItemId;
    }

    get selectedChoiceName() {
        return this.selectedChoice ? this.selectedChoice.name : '- select one -';
    }

    get selectedViewpointName() {
        if (this.viewpoints.hasOwnProperty(this.activeViewpointId)) {
            return this.viewpoints[this.activeViewpointId].name;
        }
        return '- select one -';
    }

    get selectedFactorName() {
        if (this.$route.path === this.URLS.TEMPLATE_BUILDER) {
            if (this.selectedDraftFactorResourceItemId && this.draftFactorResources.hasOwnProperty(this.selectedDraftFactorResourceItemId)) {
                return this.draftFactorResources[this.selectedDraftFactorResourceItemId].name;
            }
        } else {
            if (this.selectedFactorResourceItemId && this.factorResources.hasOwnProperty(this.selectedFactorResourceItemId)) {
                return this.factorResources[this.selectedFactorResourceItemId].name;
            }
        }
        return '- select one -';
    }

    get viewpoints() {
        return viewpointsModule.decisionViewpointsMap || {};
    }

    get unfilteredViewpoints() {
        return viewpointsModule.unfilteredViewpointsMap || {};
    }

    get singularChoiceLabel() {
        return decisionsModule.singularChoiceLabel;
    }

    get pluralChoiceLabel() {
        return decisionsModule.pluralChoiceLabel;
    }

    get singularViewpointLabel() {
        return decisionsModule.singularViewpointLabel;
    }

    get pluralViewpointLabel() {
        return decisionsModule.pluralViewpointLabel;
    }

    get singularFactorLabel() {
        return decisionsModule.singularFactorLabel;
    }

    get pluralFactorLabel() {
        return decisionsModule.pluralFactorLabel;
    }

    get activeViewpointId() {
        return viewpointsModule.activeViewpointId || '';
    }

    set activeViewpointId(viewpointId: string) {
        if (viewpointId) {
            viewpointsModule.selectActiveViewpoint(viewpointId);
        }
    }

    private async selectActiveViewpoint(viewpointId: string | null = null) {
        if (viewpointId) {
            await this.selectViewpoint(viewpointId);
        }
        viewpointsModule.selectActiveViewpoint(viewpointId);
    }

    private async selectViewpoint(viewpointId: string) {
        if (viewpointId && viewpointId !== 'ROOT') {
            await viewpointsModule.selectViewpoint(viewpointId);
        }
    }

    get scoreBarVisibility() {
        return workspaceOptionsModule.scoreBarVisibility;
    }

    set scoreBarVisibility(visible: boolean) {
        workspaceOptionsModule.changeScoreBarVisibility(visible);
    }

    get currentUserProfile() {
        return usersModule.currentUserProfile;
    }

    get selectedViewpoints() {
        return viewpointsModule.selectedViewpoints;
    };

    set selectedViewpoints(selectedViewpoints: Viewpoint[] | undefined) {
        if (!selectedViewpoints) return;
        let chosenViewpointIds = selectedViewpoints.map(v => v.viewpointId);
        let viewpointsToAdd = _.pullAll(chosenViewpointIds, viewpointsModule.selectedViewpointIds);
        let viewpointsToRemove = _.pullAll(viewpointsModule.selectedViewpointIds, chosenViewpointIds);
        viewpointsToRemove.forEach(viewpointsModule.deselectViewpoint)
        viewpointsToAdd.forEach(viewpointsModule.selectViewpoint)
    }

    get selectedDecision() {
        return decisionsModule.selectedDecision;
    }

    get appletsList() {
        return appsModule.apps;
    }

    setSelectedDecision() {
        if (
            this.decisionViewpointsList &&
            this.decisionViewpointsList.length > 0
        ) {
            viewpointsModule.selectViewpoint(
                this.decisionViewpointsList[0].viewpointId
            );
            workspaceOptionsModule.resetViewpointColumnsWidth();

        }
        if (this.choicesList && this.choicesList.length) {
            choicesModule.selectChoice(this.choicesList[0].id);
            workspaceOptionsModule.resetChoiceColumnsWidth();
        }
        if (
            this.currentUserProfile &&
            this.selectedDecision &&
            this.currentUserProfile.userId !==
                this.selectedDecision.ownerUserId
        ) {
            if (this.$route.name !== 'ChoiceSubmitter') {
                this.$router.push({ name: 'ChoiceSubmitter' });
            }
            this.section = this.URLS.CHOICE_SUBMITTER;
        } else {
            if (this.$route.name !== 'DecisionBuilder') {
                this.$router.push({ name: 'DecisionBuilder' });
            }
            this.section = this.URLS.TEMPLATE_BUILDER;
        }
    }

    get panelRight() {
        return workspaceOptionsModule.rightPanelOpen;
    }

    set panelRight(value: boolean) {
        workspaceOptionsModule.setRightPanelOpen(value);
    }

    get selectedChoice() {
        return choicesModule.selectedChoice;
    };

    set selectedChoice(selectedChoice: any) {
        if (selectedChoice) {
            choicesModule.setSelectedChoiceId(selectedChoice.id);
        } else {
            choicesModule.setSelectedChoiceId(null);
        }
    }

    get decisionViewpointsList() {
        if (this.selectedDecision) {
            return decisionsModule.decisionViewpoints[this.selectedDecision.decisionId]
        }
        return [];
    }

    get choices() {
        return choicesModule.choices;
    }

    get choicesList() {
        return choicesModule.choicesList;
    }

    get loading() {
        return this.loadingResources
            || this.processing
    }

    get pageWidth(): number {
        return this.sliderPageWidth[1] - this.sliderPageWidth[0];
    }

    get url() {
        return this.generateUrl();
    }

    get showCreateChoiceDialog() {
        return workspaceOptionsModule.showCreateChoiceDialog;
    }

    set showCreateChoiceDialog(val: boolean) {
        workspaceOptionsModule.changeShowCreateChoiceDialog(val)
    }

    get showCreateViewpointDialog() {
        return workspaceOptionsModule.showCreateViewpointDialog;
    }

    get allDecisions() {
        return _.sortBy(Object.values(decisionsModule.decisions), 'name');
    }

    set showCreateViewpointDialog(val: boolean) {
        workspaceOptionsModule.changeShowCreateViewpointDialog(val)
    }

    @Watch('sliderLeft')
    sliderLeftChange(left: number) {
        if (left > -25) {
            left = -25;
        }
        this.sliderPageWidth[1] = -1 * (left);
        this.sliderRight = -1 * (left);
    }
    
    @Watch('queryChoiceId')
    private onChangeSelectedChoiceId () {
        if(this.queryCreateChoice != 'true') {
            if (this.queryChoiceId) {
                choicesModule.selectChoice(this.queryChoiceId);
            } else if (choicesModule.choiceIds.length) {
                choicesModule.selectChoice(choicesModule.choiceIds[0]);
            }
        }
    }

    @Watch('sliderRight')
    sliderRightChange(right: number) {
        if (right < 25) {
            right = 25;
        }
        this.sliderPageWidth[0] = -1 * (right);
        this.sliderLeft = -1 * (right);
        this.$cookies.set("vp-form-width", this.sliderRight);
    }

    @Watch('navDrawer')
    navDrawerChange(newVal: boolean) {
        if (!newVal) {
            this.$emit('nav-drawer-changed', false);
        }
    }

    @Watch('navDrawerProp')
    navDrawerPropChange(newVal: boolean) {
        this.navDrawer = newVal;
        this.panelLeft = !this.panelLeft;
    }
    


    @Watch('$route', {immediate: true, deep: true})
    onRouteChange(to, from) {
        this.generateUrl();
    }

    @Watch('allDecisions',{immediate: true, deep: true})
    onAllDecisionsChange() {
        this.getUserDecisions();
    }

    @Watch('lockState', {immediate: true, deep: true})
    onLockStateChange() {
        console.log('Lock State: ' + this.queryLockState)
    }

    private async updateDecision( id: any ) {
   
    }

    private async getUserDecisions() {

        let decisions = this.allDecisions.map(async(item) => {
            item['apps'] = await appsModule.checkAppsByDecision(item.decisionId);
            return item;
        });
        
        this.decisions = await Promise.all(decisions)
    }

    private generateUrl( decId = decisionsModule.selectedDecisionId ) {
        if(this.isAuthenticated){
            let path = this.$router.currentRoute.path;
            let params: any = {
                viewpointIds: viewpointsModule.selectedViewpointIds,
                decisionId: decId,
                choiceId: choicesModule.selectedChoiceId,
                activeViewpointId: viewpointsModule.activeViewpointId,
                appEmbedId: appsModule.appId,
                appEmbedMenuId: appsModule.activeAppMenuId.toString(),
                showNonContributing: workspaceOptionsModule.contributingFactorVisibility,
                // visibleChoices: Object.keys(workspaceOptionsModule.choiceVisibility).filter((k: string) => workspaceOptionsModule.choiceVisibility[k]),
                choiceListIds: workspaceOptionsModule.activeChoiceLists,
                factorListIds: workspaceOptionsModule.activeFactorLists,
                viewpointListIds: workspaceOptionsModule.activeViewpointLists,
                activeFactorId: workspaceOptionsModule.selectedPathItemId,
                showDesc: workspaceOptionsModule.descriptionVisibility.toString(),
                showBars: workspaceOptionsModule.scoreBarVisibility.toString(),
                showIconScoring: workspaceOptionsModule.showIconScoring,
                skipGroups: workspaceOptionsModule.skipGroups,
                showNonListFactors: workspaceOptionsModule.showNonListFactors,
                viewpointSort: workspaceOptionsModule.viewpointSort,
                choiceSort: workspaceOptionsModule.choiceSort,
                openLeft: workspaceOptionsModule.openLeft.toString(),
                openRight: workspaceOptionsModule.openRight,
                choiceColumnWidth: workspaceOptionsModule.choiceColumnWidth,
                viewpointColumnWidth: workspaceOptionsModule.viewpointColumnWidth,
                choiceNumOfCols: workspaceOptionsModule.numOfCols,
                trimTopGroups: workspaceOptionsModule.trimTopGroups,
                showScores: workspaceOptionsModule.scoresVisibility.toString(),
                showKeys: workspaceOptionsModule.keysVisibility.toString(),
                showComments: workspaceOptionsModule.commentsVisibility.toString(),
                choiceFirstCol: workspaceOptionsModule.choiceFirstCol,
                showCustomRange: workspaceOptionsModule.customRangeActive.toString(),
                viewpointFirstCol: workspaceOptionsModule.viewpointFirstCol,
                rankChoiceCol: workspaceOptionsModule.rankChoiceCol,
                pinnedLeft: workspaceOptionsModule.pinnedLeft,
                pinnedRight: workspaceOptionsModule.pinnedRight,
                selectionMenu: appsModule.selectionMenu.toString(),
                showHomepage: this.isHomepage,
                mbDraggable: workspaceOptionsModule.mbDraggable.toString(),
                denomScoring: workspaceOptionsModule.denominatorScoring.toString(),
                standardize: workspaceOptionsModule.standardizeDenominator.toString(),
                brandingPrimary: this.queryBrandingPrimary ? this.queryBrandingPrimary : '',
                chartTop: this.queryChartTop,
                choiceSelectionMenu: appsModule.choiceSelectionMenu.toString(),
                lockState: this.menuItemLock,
            };
            if (Object.values(params).filter(f => f).length > 0) {
                path = path + '?'
                for (let p in params) {
                    if (params[p] && params[p] != null) {
                        if (Array.isArray(params[p]) && params[p].length > 0) {
                            path = path + (params[p] as any[]).map(v => p + '=' + v).join('&') + '&'
                        } else if (!Array.isArray(params[p])) {
                            path = path + p + '=' + params[p] + '&';
                        }
                    }
                }
                path = path.substring(0, path.length - 1);
            }
            
            //@ts-ignore
            history.pushState({}, null, path);
            this.fullPath = path;
            let re = new RegExp('([\/]{1}[aApP]*[\/]*){1}');
            if (re.test(path)) {
                appsModule.setCurrentAppUrl(path);
            }
            this.$emit('new-path', path);
        
            if (this.$router.currentRoute.name != 'AppletsGallery' && !this.menuItemLock) {
                appsModule.setMenuState({ 'menuId': appsModule.activeAppMenuId, 'url': path });
            }
            return path;
        }
        
    }

    private recenterSlider(value: any[]) {
        if (value[0] > (-25)) {
            value[0] = -25;
            this.sliderPageWidth[0] = -25;
        }
        this.sliderLeft = value[0];
        if (value[1] < (25)) {
            value[1] = 25;
            this.sliderPageWidth[1] = 25;
        }
        this.sliderRight = value[1];
    }

    private async createViewpoint(viewpoint: any) {
        this.emitProcessingMessage();
        this.createViewpointDialog = false;
        try {
            if (!this.selectedDecision) return;
            await decisionsModule.createDecisionViewpoint({
                decisionId: this.selectedDecision.decisionId,
                name: viewpoint.name,
                description: viewpoint.description
            })
            this.emitSuccessMessage();
        } catch (err) {
            this.emitFailedMessage(err)
        }
    }

    private async createAutocreateViewpoint(payload: any) {
        this.emitProcessingMessage();
        this.createViewpointDialog = false;
        let newViewpoint = {
            viewpointId: '',
        };
        try {
            if (!this.selectedDecision) return;
            let newVp = {
                decisionId: this.selectedDecision.decisionId,
                name: payload.name,
                description: payload.description,
                addToList: true
            }
            if(this.queryTemplateViewpoint != null && this.queryTemplateViewpoint in this.unfilteredViewpoints) {
                //Clone template into new
                newViewpoint = await viewpointsModule.cloneViewpoint({
                    original: this.unfilteredViewpoints[this.queryTemplateViewpoint],
                    newViewpoint: newVp,
                    includeWeights: this.queryIncludeWeights === 'true',
                    includeKeys: this.queryIncludeKeys === 'true',
                    includeScores: this.queryIncludeScores === 'true',
                })
                
            } else {
               newViewpoint =  await decisionsModule.createDecisionViewpoint(newVp);
                if(newViewpoint?.viewpointId != '' && workspaceOptionsModule.activeViewpointLists.length > 0) {
                    decisionsModule.addViewpointToActiveLists(newViewpoint.viewpointId)
                }
            }
            this.emitSuccessMessage();
            this.showCreateViewpointDialog = false;
        } catch (err) {
            this.emitFailedMessage(err)
        }
    
    }

    private async editAutocreateViewpoint(payload: Viewpoint) {
        await viewpointsModule.selectActiveViewpoint(payload.viewpointId);
        this.showCreateViewpointDialog = false;
    }

    private async createDecision(decisionInput: any) {
        this.createDecisionDialog = false;
        this.emitProcessingMessage();
        let newDecision = await decisionsModule.createDecision({
            name: decisionInput.name,
            description: decisionInput.description
        });
        await decisionsModule.selectDecision(newDecision.decisionId)
        this.emitSuccessMessage();
    }

    private async deleteDecision(decisionId: string) {
        await decisionsModule.deleteDecision(decisionId)
    }

    private async editDecision(payload: Decision) {
        this.editDecisionDialog = false;
        NotificationEventBus.emitProcessingMessage();
        try {
            await decisionsModule.updateDecision(payload);
            NotificationEventBus.emitSuccessMessage();
        } catch (err) {
            NotificationEventBus.emitFailedMessage(err);
        }
    }

    private emitProcessingMessage() {
        this.processing = true;
        NotificationEventBus.emitProcessingMessage()
    }

    private emitSuccessMessage() {
        this.processing = false;
        NotificationEventBus.emitSuccessMessage()
    }

    private emitFailedMessage(error: any) {
        this.processing = false;
        NotificationEventBus.emitFailedMessage(error);
    }

    private checkViewpointsForOwner(userId: string): boolean {
        if(this.decisionViewpointsList.length === 0 || this.decisionViewpointsList === null) {
            return false;
        }
        for(let viewpoint of this.decisionViewpointsList) {
            if(viewpoint.ownerUserId === userId) {
                return true;
            }
        }
        return false;
    }

    private updateScoringKeyDefinition(scoringKeys: any[]) {
        let scoringKeyDefinition: ScoringKeyDefinition | null;
        if (scoringKeys == null || scoringKeys.length === 0) {
            scoringKeyDefinition = null;
        } else {
            scoringKeyDefinition = {
                scoringKeys: scoringKeys,
                notApplicableEnabled: false
            }
        }

        NotificationEventBus.emitProcessingMessage();
        scoringKeysModule.updateDecisionScoringKeyDefinition(scoringKeyDefinition)
            .then(() => {

            })
            .catch((error: any) => {
                NotificationEventBus.emitFailedMessage({message: error.message});
            });
    }

    private async createChoice(name: string) {
        let choice: Choice = {
            name: name,
            image: null,
            lastUpdatedTimestamp: null,
            creationTimestamp: null,
            visibility: 'ALL',
            ownerUserId: this.currentUserProfile.userId
        }
        let newChoice = await choicesModule.createChoice(choice);
        this.showCreateChoiceDialog = false;
        if(workspaceOptionsModule.activeChoiceLists.length > 0) {
            await decisionsModule.addChoiceToActiveLists(newChoice.id)
            await decisionsModule.getDecisionLists();
        }
        await choicesModule.fetchChoices();
        choicesModule.selectChoice(newChoice.id);
    }

    private editChoice(choice: Choice) {
        choicesModule.selectChoice(choice.id)
        this.showCreateChoiceDialog = false;
    }


}
